export default __webpack_public_path__ + "static/media/gstr_step_2.533be656.png";